export default __webpack_public_path__ + "static/media/break26.e7c6d258.jpg";